import { render, staticRenderFns } from "./TestesAb.vue?vue&type=template&id=be453006&"
import script from "./TestesAb.vue?vue&type=script&lang=js&"
export * from "./TestesAb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports